export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/consultations-made/resources/data.js